// @ts-ignore
import SuccessIcon from './SuccessIcon.svg'
// @ts-ignore
import CopyIcon from './CopyIcon.svg'
// @ts-ignore
import LinkIcon from './LinkIcon.svg'

export { SuccessIcon, CopyIcon, LinkIcon }
